module.exports = __webpack_public_path__ + "fe8dc76dea648c7718e845c1524dd594.png";